import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=06e71e04&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=06e71e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e71e04",
  null
  
)

export default component.exports